import config from "../config";
//eshow路径
export function eshowURL() {
  return config.tinymceUrl;
}
//公共图片路径处理文件
export function forMat() {
  return config.fontUrl;
}
//转发微信下载图片
export function imgDownwx(){
  return config.wxImgdowngL;
}

//富文本路径
export function editUrl(){
  return config.tinymceUrl;
}

//截取文件名称
export function intercept (url) {
    let originname = url.split('/')[url.split('/').length - 1] //获取最后‘/’后的带时间戳的文件名
    let filename = originname.slice(13)                       //从第14位开始截取，去掉13位时间戳
    return filename
}

// 上传文件地址
export function baseFileUrl() {
  return config.backendUrl+config.baseFileUrl;
}

// 上传展商服务 上传参展人员excel表格
export function uploadExcelUrl() {
  return config.backendUrl+config.uploadExcelUrl;
}

// 上传团体邀请excel表格
export function uploadExcelAudience(){
  return config.backendUrl+config.uploadExcelAudience;
}

// 获取前端编辑器资源目录
export function editorResourceUrl(){
  return config.tinymceUrl+config.editPrefix;
}
export function backFront() {
  return config.backFront;
}

// 参展申请
export function viewApply() {
  return config.viewApply;
}
// 线上展会展商列表页
export function backExhibitionList() {
  return config.backExhibitionList;
}
//微信邀请的url地址
export function wxRegister() {
  return config.wxRegister;
}
// 展会官网
export function hzZhanhui() {
  return config.hzzhanhui;
}
// 我要参展
export function viewcz() {
  return config.viewcz;
}
// 我要参观
export function viewcg() {
  return config.viewcg;
}
// 展位图
export function zwt() {
  return config.zwt;
}
// 展会日程
export function zhrc() {
  return config.zhrc;
}

//转发微信icon图标地址
export function wxIconUrl(){
 let baseUrl = config.wxImgdowngL.split('#');
  return baseUrl[0]+"logo.png";
}

// 判断浏览器的头是否为移动端
export function perfix() {
  // header 手机特征信息
  if (navigator.userAgent.match(/(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i)) {
    //显示移动端的代码
    return 'mobile/';
    // return '';
  } else {
    //显示非移动端的代码
    return '';
  }
}